import { useReferralsContext } from '@user/components/Referrals/context'
import { setEmployeeActionCreator } from '@user/components/Referrals/state'
import { EmployeeUserOption } from './useData'
import { useCallback, useEffect, useMemo } from 'react'
import { useFormikContext } from 'formik'
import { ILeadFormModel } from '@user/components/Leads/AddLeadPage/typings'
import { referralDataMapperModelToDTO } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralDrawer/hooks/utils'
import { ReferralFormProps } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralForm/UpdateReferralForm'
import { ReferralFormVariant } from '@user/components/Referrals/components/UpdateReferral/TidalUpdateReferral'

export function useHandlers({ formVariant }: ReferralFormProps) {
  const [state, dispatch] = useReferralsContext()
  const [{ referralEmployeeValue, referralEmployeeId }] = useReferralsContext()
  const context = useFormikContext<ILeadFormModel>()

  const isInline = useMemo<boolean>(() => {
    return formVariant === ReferralFormVariant.Inline
  }, [formVariant])

  const isInValid = useMemo<boolean>(() => {
    return Boolean(
      isInline && context?.errors?.referral && context?.touched?.referral,
    )
  }, [context?.errors?.referral, context?.touched?.referral, isInline])

  const handleTidalEmployeeSelectChange = useCallback(
    (value: EmployeeUserOption | null) => {
      dispatch(
        setEmployeeActionCreator({
          id: value?.id || '',
          name: value?.value || null,
        }),
      )
    },
    [dispatch],
  )

  function handleEmployeeSelectChange(
    _event: React.SyntheticEvent<Element, Event>,
    value: EmployeeUserOption | null,
  ) {
    dispatch(
      setEmployeeActionCreator({
        id: value?.id || '',
        name: value?.value || null,
      }),
    )
  }

  useEffect(() => {
    if (isInline) {
      const model = referralDataMapperModelToDTO({
        ...state,
        referralEmployeeValue: referralEmployeeValue,
        referralEmployeeId: referralEmployeeId,
      })
      context?.setFieldValue?.('referral', model)
    }
  }, [referralEmployeeId, isInline])

  return {
    handleEmployeeSelectChange,
    handleTidalEmployeeSelectChange,
    isInValid,
    error: isInValid ? context?.errors?.referral : undefined,
  }
}
